module.exports = __webpack_public_path__ + "static/16-3bf1241a2a53f344609363e2e3796657.jpg";